import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "WatchlistApp/ts/features/add-to-watchlist-modal/components/watchlist-group-element.component";
const _c0 = a0 => ({ "linked-list-sublist": a0 });
function WatchlistGroupComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "ycn-watchlist-group-element", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const watchlist_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("watchlistGroupType", ctx_r1.watchlistGroupType)("watchlistData", watchlist_r1);
} }
/**
 *
 * WatchlistGroup Component
 *
 * This component is responsible for displaying either watchlists that contain ('watching On')
 * or don't contain a security ('Other Watchlists')
 *
 * * Input Properties
 * watchlistGroupType: Whether or not the group of watchlistGroupData is containing or excluding a security.
 * watchlistGroupData: An array of all of the watchlists.
 */
export class WatchlistGroupComponent {
    ngOnInit() {
        this.watchlistGroupTitle = this.watchlistGroupType === 'containing' ? 'Watching On' : 'Other Watchlists';
    }
}
WatchlistGroupComponent.ɵfac = function WatchlistGroupComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WatchlistGroupComponent)(); };
WatchlistGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WatchlistGroupComponent, selectors: [["ycn-watchlist-group"]], inputs: { watchlistGroupType: "watchlistGroupType", watchlistGroupData: "watchlistGroupData" }, standalone: false, decls: 3, vars: 6, consts: [[1, "linked-list-header", 3, "textContent"], [1, "linked-list-body", 3, "ngClass"], [4, "ngFor", "ngForOf"], [3, "watchlistGroupType", "watchlistData"]], template: function WatchlistGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, WatchlistGroupComponent_div_2_Template, 2, 2, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("textContent", ctx.watchlistGroupTitle);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx.watchlistGroupType === "excluding"));
        i0.ɵɵattribute("data-test-id", ctx.watchlistGroupTitle);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.watchlistGroupData);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i2.WatchlistGroupElementComponent], encapsulation: 2 });
